import { useScrollReveal } from "@/hooks/useScrollReveal";

const sinergyPillars = [
  {
    number: "01",
    title: "Branding Aesthetic yang Menjual Dirinya Sendiri",
    description:
      "Bahasa desain yang dirancang untuk magnetik di Instagram. Setiap sudut menjadi iklan gratis — pelanggan Anda yang melakukan promosi.",
  },
  {
    number: "02",
    title: "Penyelamat Jam Makan Siang",
    description:
      "Integrasikan modul F&B makanan berat yang sudah teruji — rice bowl, menu signature, hingga paket keluarga — untuk menggandakan trafik siang hari dan menghentikan kerugian di jam-jam sepi.",
  },
  {
    number: "03",
    title: "Operasional Plug-and-Play",
    description:
      "SOP, jaringan supplier, training staff, dan sistem POS dikemas dalam satu paket operasional. Buka dalam hitungan minggu, bukan tahun.",
  },
  {
    number: "04",
    title: "Mesin Komunitas Hangout",
    description:
      "Program komunitas hangout — event, ritual loyalty, dan community night — yang mengubah pengunjung pertama menjadi pelanggan mingguan.",
  },
];

const SinergySection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section id="sinergy" ref={sectionRef} className="py-28 md:py-40 bg-background">
      <div className="container mx-auto">
        <div className="max-w-2xl mb-20 reveal-on-scroll">
          <p className="uppercase tracking-[0.3em] text-xs text-terracotta mb-5">
            Sistem Sinergi
          </p>
          <h2 className="text-4xl md:text-5xl font-serif text-espresso leading-tight">
            Mayoritas cafe mati pelan-pelan antara <em className="italic text-terracotta">jam 10 pagi sampai 5 sore</em>.
          </h2>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
            Interior yang cantik saja tidak cukup. Cafe yang menguntungkan menyeimbangkan daya tarik aesthetic dengan disiplin operasional dan menu yang dirancang untuk setiap jam dalam sehari. Itulah Sistem Sinergi.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-border">
          {sinergyPillars.map((pillar, index) => (
            <article
              key={pillar.number}
              className="reveal-on-scroll bg-background p-10 md:p-14 hover:bg-cream transition-[var(--transition-smooth)] group"
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <div className="font-serif text-terracotta text-sm tracking-widest mb-4">
                {pillar.number}
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-espresso mb-4 group-hover:translate-x-1 transition-transform duration-500">
                {pillar.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {pillar.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SinergySection;
